// extracted by mini-css-extract-plugin
export var disabled = "_q-a";
export var hierarchyLinkGray = "_q-4";
export var hierarchyLinkUnderline = "_q-3";
export var hierarchyPrimary = "_q-0";
export var hierarchySecondary = "_q-1";
export var hierarchyTertiary = "_q-2";
export var pressed = "_q-6";
export var themeAction = "_q-5";
export var themeDestructive = "_q-8";
export var themeNormal = "_q-7";
export var themeSuccess = "_q-9";